module.exports = __webpack_public_path__ + "img/icon-01.16bfb600.png";